<app-home-page-header [homePageHeader]="faqHeader"></app-home-page-header>
